module.exports = __webpack_public_path__ + "img/cee3706.png";